import React from 'react';

import { Textarea } from '@chakra-ui/react';
import { GlobalError, InternalFieldName, UseFormRegisterReturn } from 'react-hook-form';

import { FormControl } from '../FormControl/FormControl';

type FormTextareaProps<TFieldName extends InternalFieldName = InternalFieldName> = {
	label: string;
	type?: string;
	error: GlobalError | undefined;
	helperText?: string;
	defaultValue?: string;
	className?: string;
} & Omit<UseFormRegisterReturn<TFieldName>, 'ref'>;

export const FormTextarea = React.forwardRef<HTMLTextAreaElement, FormTextareaProps>(
	(props, ref) => {
		const { type, ...formControlProps } = props;
		const { helperText, required, className, ...textareaProps } = props;
		return (
			<FormControl {...formControlProps}>
				<Textarea ref={ref} id={props.name} size="sm" color="secondary.700" {...textareaProps} />
			</FormControl>
		);
	},
);
